import Vue from "vue";
import Vuex from "vuex";
import MyLocalStorage from "./utils/MyLocalStorage";
import request from "./utils/Request.js";
// import MyLocalStorage from "./utils/MyLocalStorage";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      username: "",
      nickname: ""
    },
    configs: {
      "PB:LINK_DOWNLOAD_LIMIT": "10",
      "PB:LINK_DOWNLOAD_LIMIT_EXPIRE": "1",
      "PB:LINK_EXPIRE": "2",
      "PB:LINK_STORAGE_SIZE": "10737418240",
      "PB:SINGLE_TRANSFER_NUMBER": "1000",
      "PB:SINGLE_TRANSFER_SIZE": "104857600",
      "PB:VIP_LINK_EXPIRE": "0",
      "PB:VIP_LINK_STORAGE_SIZE": "107374182400",
      "PB:VIP_SINGLE_TRANSFER_SIZE": "1073741824"
    },
    step: 1
  },
  getters: {
    nickname: state =>
      state.user.nickname
        ? state.user.nickname
        : state.user.username
        ? state.user.username.slice(0, state.user.username.indexOf("@"))
        : "",
    singleTransferSize: state =>
      state.user.subscriber
        ? state.configs["PB:VIP_SINGLE_TRANSFER_SIZE"]
        : state.configs["PB:SINGLE_TRANSFER_SIZE"]
  },
  mutations: {
    set_user(state, user) {
      $.extend(state.user, user);
      // state.user = user;
      MyLocalStorage.setUserInfo(state.user);
    },
    reset_user(state) {
      state.user = {
        username: "",
        nickname: ""
      };
      MyLocalStorage.setUserInfo(state.user);
    },
    set_configs(state, configs) {
      state.configs = configs;
    },
    set_step(state, step) {
      state.step = step;
    }
  },
  actions: {
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        request({
          baseURL: process.env.VUE_APP_USER_API_URL,
          url: "/v2/user/info"
        })
          .then(response => {
            commit("set_user", response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
});
